import 'css-chunk:src/Footer/Footer.module.scss';export default {
  "footer": "footer__zVN9l"
};